import React, {useState} from 'react'
import Select from 'react-select'

const FacilityRow = ({filter, conditionsList, locations, updateCondition, updateValue}) => {
  return (
    <span>
      <i className='fa fa-hourglass-start' aria-hidden='true' title='longer execution time'></i>&nbsp;
      <select
        name='filter-condition'
        value={filter.condition}
        onChange={e=> updateCondition(e.target.value)}>
        { conditionsList.map((o, i) => <option key={i} value={o}>{o}</option>) }
      </select>&nbsp;
      { !['is empty', 'is not empty'].includes(filter.condition) &&
        <Select
          className='locations-selector-multi'
          multi
          searchable
          autosize
          clearable={false}
          closeOnSelect={false}
          removeSelected={false}
          value={filter.value.map(data=>{return {value: data, label: locations.filter(el=>data == el.id)[0].name}})}
          options={locations.map(data=>{return {value: data.id, label: data.name}})}
          onChange={(values) => updateValue(values.map(data=>data.value))}/>
      }
    </span>
  )
}

export default FacilityRow
